export const createSecurityTrailer = ({ keyId, keyVersion, hmac, nonce }) => {
  return {
    KeyIdentifier: keyId,
    KeyVersion: keyVersion,
    Hmac: hmac.toString('base64'),
    Nonce: nonce.toString('base64'),
    AdyenCryptoVersion: 1,
  };
};
